var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDemo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1948754324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275916"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 6,
    cy: 7.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    opacity: 0.5,
    cx: 6,
    cy: 18.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    opacity: 0.6,
    cx: 17,
    cy: 7.5,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    opacity: 0.3,
    cx: 17,
    cy: 18.5,
    r: 4,
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo);
export default __webpack_public_path__ + "static/media/demo.0236f2b1917d17169151eef1c331c733.svg";
export { ForwardRef as ReactComponent };